import script from "./Select2.vue?vue&type=script&setup=true&lang=js"
export * from "./Select2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__